import { render, staticRenderFns } from "./OtzpatsList.vue?vue&type=template&id=7c29ef70&scoped=true&"
import script from "./OtzpatsList.vue?vue&type=script&lang=js&"
export * from "./OtzpatsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c29ef70",
  null
  
)

export default component.exports